import AuthService from "../services/auth.service";

export const getAccess = () => {
    const user = AuthService.getCurrentUser();
    const isOwner = !user || user.isOrganizationOwner !== false;
    const permissions = user?.permissions || {};

    return {
        user,
        isOwner,
        routeClaims: isOwner ? null : (permissions.routeClaims || ["/domov"]),
        write: isOwner || Boolean(permissions.write),
        deleteFuneral: isOwner || Boolean(permissions.deleteFuneral),
        seePrices: isOwner || Boolean(permissions.seePrices)
    };
};

export const hasRouteClaim = (claim) => {
    const access = getAccess();
    return access.isOwner || claim === "/domov" || access.routeClaims.includes(claim);
};

export const canAccessPath = (path) => {
    const access = getAccess();
    if (access.isOwner) return true;
    if (path === "/domov" || path.startsWith("/domov/")) return true;
    if (path === "/organizacia" || path.startsWith("/profil")) return false;
    if (["/faktura", "/dodaci_list", "/cennik"].some((suffix) => path.endsWith(suffix))) {
        return access.seePrices;
    }
    if (path === "/novy-pohreb") return access.write && hasRouteClaim("/novy-pohreb");
    if (path.includes("/upravit") || path.includes("/pohreb/produkty/") || path.includes("/pohreb/sluzby/") || path.includes("/evidencia") || path.includes("/miesto")) {
        return access.write;
    }
    if (path.startsWith("/pohreb/")) return true;

    const matchingClaim = (access.routeClaims || [])
        .filter((claim) => claim !== "/domov")
        .sort((a, b) => b.length - a.length)
        .find((claim) => path === claim || path.startsWith(`${claim}/`));
    return Boolean(matchingClaim);
};
